import CreateOrEditCompany from './CreateOrEditCompany';
export default CreateOrEditCompany;
